<template>
  <div class="wrap">
    <div class="index-wrap">
      <p class="bg bg1"></p>
      <div class="swiper adSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img
              class="image-game"
              src="../assets/images/landing/slide_01.jpg"
            />
          </div>
          <div class="swiper-slide">
            <img
              class="image-game"
              src="../assets/images/landing/slide_02.jpg"
            />
          </div>
        </div>
      </div>
      <p class="bg bg2">
      </p>
      <a
        href="javascript:;"
        @click="
          statistics()
        "
        class="btn"
      ></a>
    </div>
  </div>
</template>

<script src="../../public/assets/swiper-bundle.min.js"></script>

  <script>
  export default {
    components: {},
    name: "landing3",
    data() {
      return {
        adSwiper: null,
      };
    },
    created() {
      fbq('init', '864027598790324');
      fbq('track', 'PageView');
    },
    mounted() {
      this.adSwiper = new Swiper(".adSwiper", {
        autoplay: {
          delay: 2000, //3秒切换一次
          pauseOnMouseEnter: true, //悬停停止切换
        },
        loop: true,
        allowTouchMove: true,
      });
    },
    //methods中定义事件
    methods: {
      // 打点统计
      statistics() {
        fbq('track','Lead');
        // 新开链接跳转
        window.open('https://apps.apple.com/kr/app/%EC%82%BC%EA%B5%AD%EC%A7%80-%EC%98%A4%EB%A6%AC%EC%A7%842-%EC%A0%81%EB%B2%BD%EB%8C%80%EC%A0%84/id6447394503?ppid=5a440a46-95bc-4a0a-9e27-af63ed1fac26');
      },
    },
  };
</script>
  
  <style lang="less" scoped>
  .wrap {
    background-color: #000;
  }
  .bg {
    width: 100%;
    overflow: hidden;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .bg1 {
    height: 632rem;
    background-image: url(../assets/images/landing/bg_01.jpg);
  }
  .bg2 {
    height: 1131rem;
    background-image: url(../assets/images/landing/bg_02.jpg);
  }
  .adSwiper{
    width: 750rem;
    height: 587rem;
  }
  .swiper-slide img{
    width: 100%;
  }
  .btn {
    position: fixed;
    left: 50%;
    bottom: 15rem;
    z-index: 10;
    width: 718rem;
    height: 130rem;
    margin-left: -359rem;
    background-image: url(../assets/images/landing/btn.png);
    background-size: 100% 100%;
  }
  @media screen and (min-width: 750px) {
    .bg1 {
      height: 632px;
    }
    .bg2 {
      height: 1131px;
    }
    .adSwiper{
      width: 750px;
      height: 587px;
    }
    .index-wrap {
      width: 100%;
      min-width: 750px;
      max-width: 750px;
      margin: 0 auto;
    }
    .btn{
      width: 718px;
      height: 130px;
      bottom: 15px;
      margin-left: -359px;
    }
  }
</style>
    